var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5004 10.6583C17.3693 12.0768 16.837 13.4287 15.9656 14.5557C15.0943 15.6826 13.92 16.5382 12.5802 17.0221C11.2403 17.5061 9.79039 17.5984 8.39999 17.2884C7.00959 16.9784 5.73623 16.2788 4.72893 15.2715C3.72162 14.2642 3.02202 12.9908 2.712 11.6004C2.40197 10.21 2.49434 8.76007 2.97829 7.42025C3.46224 6.08042 4.31776 4.90614 5.44475 4.03479C6.57173 3.16345 7.92357 2.63109 9.34207 2.5C8.51158 3.62356 8.11195 5.00787 8.21585 6.40118C8.31975 7.79448 8.92029 9.10421 9.90824 10.0922C10.8962 11.0801 12.2059 11.6807 13.5992 11.7846C14.9925 11.8885 16.3768 11.4888 17.5004 10.6583Z",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonIcon);
export default __webpack_public_path__ + "static/media/MoonIcon.76aea863c540e7c9c517e6585ed9d783.svg";
export { ForwardRef as ReactComponent };